import { Link } from "@tanstack/react-router";
import type { PortfolioProject } from "@/content/portfolio";
import { Picture } from "@/components/media/Picture";

export function PortfolioCard({ project }: { project: PortfolioProject }) {
  const primary = project.metrics[0];
  return (
    <Link
      to="/portfolio/$slug/"
      params={{ slug: project.slug }}
      className="group surface-card overflow-hidden flex flex-col transition-transform hover:-translate-y-1"
    >
      <div className="aspect-[16/10] overflow-hidden bg-surface-2">
        <Picture
          variantKey={project.coverVariant}
          alt={`${project.client} — ${project.title}`}
          sizes="(min-width: 1280px) 400px, (min-width: 640px) 45vw, 100vw"
          className="block h-full w-full"
          imgClassName="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <div className="flex items-center justify-between text-[0.7rem] uppercase tracking-widest text-muted-foreground">
          <span>{project.industry}</span>
          <span>{project.window}</span>
        </div>
        <h3 className="mt-3 font-display text-xl leading-tight text-foreground">
          {project.client}
        </h3>
        <p className="mt-2 text-sm text-muted-foreground line-clamp-3">
          {project.tagline}
        </p>
        <div className="mt-5 flex items-baseline gap-3">
          <span className="font-display text-3xl text-primary">{primary.value}</span>
          <span className="text-xs text-muted-foreground">{primary.label}</span>
        </div>
        <div className="mt-4 flex flex-wrap gap-1.5">
          {project.services.slice(0, 3).map((s) => (
            <span
              key={s}
              className="text-[0.65rem] uppercase tracking-wider text-muted-foreground border border-border rounded-full px-2 py-0.5"
            >
              {s}
            </span>
          ))}
        </div>
        <div className="mt-6 text-sm text-primary">Read the story →</div>
      </div>
    </Link>
  );
}
